const STORAGE_KEY = 'talkiemate_email_verification_notice_dismissed';

export function emailVerificationNotice() {
    const notice = document.querySelector('.js-email-verification-notice');
    if (!notice) {
        return;
    }

    try {
        if (window.sessionStorage.getItem(STORAGE_KEY) === '1') {
            notice.remove();
            return;
        }
    } catch (error) {
        // Storage can be unavailable in privacy modes; the notice remains usable.
    }

    const resendButton = notice.querySelector('.js-email-verification-resend');
    const closeButton = notice.querySelector('.js-email-verification-close');
    const status = notice.querySelector('.js-email-verification-status');
    const label = notice.querySelector('.js-email-verification-label');
    const initialLabel = label ? label.textContent.trim() : '';

    if (closeButton) {
        closeButton.addEventListener('click', () => {
            notice.classList.add('is-dismissing');
            try {
                window.sessionStorage.setItem(STORAGE_KEY, '1');
            } catch (error) {
                // Dismissal still works for the current page when storage is unavailable.
            }
            window.setTimeout(() => notice.remove(), 180);
        });
    }

    if (!resendButton) {
        return;
    }

    resendButton.addEventListener('click', async () => {
        if (resendButton.disabled) {
            return;
        }

        resendButton.disabled = true;
        notice.classList.remove('has-error', 'is-success');
        notice.classList.add('is-loading');

        const body = new URLSearchParams({
            action: resendButton.dataset.action || '',
            nonce: resendButton.dataset.nonce || '',
        });

        try {
            const response = await fetch(resendButton.dataset.ajaxUrl || '', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
                body: body.toString(),
            });
            const result = await response.json();
            const message = result && result.data && result.data.message
                ? result.data.message
                : 'Error — please try again';

            status.textContent = message;
            notice.classList.toggle('is-success', Boolean(result.success));
            notice.classList.toggle('has-error', !result.success);
            if (result.success && label) {
                label.textContent = 'Email sent';
            }
        } catch (error) {
            status.textContent = 'Error — please try again';
            notice.classList.add('has-error');
        } finally {
            notice.classList.remove('is-loading');
            window.setTimeout(() => {
                resendButton.disabled = false;
                if (label) {
                    label.textContent = initialLabel;
                }
            }, 3000);
        }
    });
}
